import { unregisterPeriodicBadgeSync } from '../../components/service-worker-init/register-periodic-badge-sync';
import { clearAppBadge } from './app-badge';

// Cleans up all installed-PWA badge state on logout: clears the app icon badge and
// its stored count, and unregisters Periodic Background Sync so the browser stops
// waking the Service Worker to refresh a badge for a signed-out user. Without this the
// previous user's unread count could linger on the icon (and periodic sync would keep
// firing). Best-effort and fully feature-detected — safe to call in any environment.
export const cleanupAppBadgeOnLogout = async (): Promise<void> => {
  await clearAppBadge();

  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  const registration = navigator.serviceWorker.controller
    ? await navigator.serviceWorker.ready.catch(() => null)
    : ((await navigator.serviceWorker.getRegistration().catch(() => null)) ?? null);

  if (!registration) return;

  await unregisterPeriodicBadgeSync(registration);
};
